import React, { useEffect, createContext, useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import { LoginUser } from '../utils/notification';

export const NotificationContext = createContext({
  identifyUser: () => {},
});

export const NotificationContextProvider = ({ children }) => {
  const ref = useRef(false);

  const {
    authentication: { user: _user },
  } = useSelector(state => state);

  useEffect(() => {
    if (_user.isLoggedIn() && !ref.current) {
      LoginUser(
        _user.id,
        _user.email,
        _user.dealershipName || _user.firstName,
        _user.phone || _user.phoneNumber
      );
      ref.current = true;
    } else if (!_user.isLoggedIn() && ref.current) {
      ref.current = false;
    }
  }, [_user]);

  return (
    <NotificationContext.Provider value={{ identifyUser: LoginUser }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  return context;
};
